import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Clinics } from 'src/app/models/database/clinic';
import { Employee } from 'src/app/models/database/employee';
import { Id } from 'src/app/models/database/types/id.model';
import { InviteToken } from 'src/app/models/tokens/invite-token.model';
import { HttpService } from '../http-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends HttpService {

  constructor(private http: HttpClient) {
    super('auth')
  }

  verifyIfCnpjExists(cnpj: string): Observable<void> {
    return this.http.head<void>(`${this.url}/clinic?cnpj=${cnpj}`)
  }

  verifyIfEmployeeExists(filter: Employee): Observable<void> {
    let queryArray = []
    for (const key in filter) {
      queryArray.push(`${key}=${filter[key]}`)
    }
    const query = queryArray.join('&')
    return this.http.head<void>(`${this.url}/employee?${query}`)
  }

  verifyIfRecoverTokenExists(recoverToken: string): Observable<void> {
    return this.http.head<void>(`${this.url}/recover-password?recovertoken=${recoverToken}`)
  }

  getInviteTokenData(invitetoken: string): Observable<InviteToken> {
    return this.http.get<InviteToken>(`${this.url}/invite`, { headers: { invitetoken } })
  }

  verifyIfEmployeeIsRelatedToClinic(employeeEmail: string, clinicId: Id): Observable<void> {
    return this.http.head<void>(`${this.url}/clinic/${clinicId}?email=${employeeEmail}`)
  }

  getClinics(employeeId: Id): Observable<Clinics> {
    return this.http.get<Clinics>(`${this.url}/employee/${employeeId}/clinics`)
  }

  setClinic(clinicId: Id): Observable<string> {
    return this.http.get<string>(`${this.url}/set-clinic/${clinicId}`)
  }
}
